export default __webpack_public_path__ + "static/banner-saving-for-financial-freedom-7193bac515273e9eff2f7936efde25e4.jpg";